import IntegrationsModel from '../../Integrations/IntegrationsModel';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { WizardStep } from '../../../models/index';
import { authenticationStep } from '../../../resources/IntegrationsData';
import { RoutePaths } from '../../../routes/history';

export const useSortedWizardSteps = (
  viewModel: IntegrationsModel,
  viewModelRef: React.MutableRefObject<IntegrationsModel>,
  history: ReturnType<typeof useHistory>,
) => {
  const [steps, setSteps] = useState<WizardStep[]>();

  useEffect(() => {
    if (viewModelRef.current?.activeIntegration?.wizardSteps) {
      viewModelRef.current.activeIntegration.wizardSteps.sort(
        (a: WizardStep, b: WizardStep) => a.stepOrder - b.stepOrder,
      );
      let sortedWizardSteps: WizardStep[] = [
        authenticationStep,
        ...viewModelRef.current.activeIntegration.wizardSteps,
      ].map((step, index) => {
        step.stepOrder = index;
        return step;
      });
      setSteps([...sortedWizardSteps]);
    } else {
      history.push(RoutePaths.Integrations().toString());
    }
  }, [viewModel.activeIntegration, history]);

  return steps;
};
